import { useState } from 'react'
import Card from '@/components/ui/Card'
import Blob from '@/components/Blob'

export default function PartnerApply() {
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)
    const payload = Object.fromEntries(formData.entries())
    console.info('Partner inquiry submitted', payload)
    setSubmitted(true)
    form.reset()
  }

  return (
    <div className="space-y-10">
      <section className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-shell via-white to-shell px-6 py-10 shadow-soft">
        <Blob className="absolute -top-24 -right-16 h-60 w-60 opacity-30" />
        <Blob className="absolute -bottom-20 -left-16 h-48 w-48 opacity-30" />
        <div className="relative z-10 space-y-4 text-cocoa">
          <span className="inline-flex items-center rounded-full bg-white/80 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-cocoa/70">
            Partner with us
          </span>
          <h1 className="text-3xl font-semibold tracking-tight">Share your organization’s details</h1>
          <p className="text-sm text-cocoa/70">
            Tell us about your team, the support you’d like to offer, and the classrooms or communities you hope to reach. We’ll
            follow up within one business day.
          </p>
        </div>
      </section>

      <Card className="space-y-6 p-6">
        <form
          name="partner-apply"
          method="POST"
          data-netlify="true"
          netlify-honeypot="bot-field"
          className="space-y-4"
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="form-name" value="partner-apply" />
          <p className="hidden">
            <label className="text-sm text-cocoa/70">
              Don’t fill this out: <input name="bot-field" />
            </label>
          </p>
          <label className="block space-y-2 text-sm text-cocoa/80">
            <span className="font-medium text-cocoa">Organization</span>
            <input
              name="organization"
              required
              placeholder="Organization name"
              className="w-full rounded-xl border border-cocoa/10 bg-white px-4 py-3 shadow-inner transition focus:border-brick/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
            />
          </label>
          <div className="grid gap-4 sm:grid-cols-2">
            <label className="space-y-2 text-sm text-cocoa/80">
              <span className="font-medium text-cocoa">Contact name</span>
              <input
                name="contact_name"
                required
                placeholder="Full name"
                className="w-full rounded-xl border border-cocoa/10 bg-white px-4 py-3 shadow-inner transition focus:border-brick/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
              />
            </label>
            <label className="space-y-2 text-sm text-cocoa/80">
              <span className="font-medium text-cocoa">Email</span>
              <input
                name="email"
                type="email"
                required
                placeholder="you@example.com"
                className="w-full rounded-xl border border-cocoa/10 bg-white px-4 py-3 shadow-inner transition focus:border-brick/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
              />
            </label>
          </div>
          <label className="block space-y-2 text-sm text-cocoa/80">
            <span className="font-medium text-cocoa">How would you like to collaborate?</span>
            <textarea
              name="message"
              required
              rows={5}
              placeholder="Share focus areas, timeline, and how we can partner."
              className="w-full rounded-xl border border-cocoa/10 bg-white px-4 py-3 shadow-inner transition focus:border-brick/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick"
            />
          </label>
          <button type="submit" className="btn">
            Submit inquiry
          </button>
        </form>
        {submitted ? (
          <div className="rounded-xl bg-mint/10 px-4 py-3 text-sm text-mint">
            Thanks! We’ll review your note and reach out with next steps shortly.
          </div>
        ) : null}
      </Card>
    </div>
  )
}
